// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"134":"328b2c44","197":"c151e07d","231":"ff2fa7a3","311":"6887dd0e","417":"7735c479","776":"13f16e0f"}[chunkId] + ".chunk.js";
};